import { type ConsentInfoResponse } from '@logto/schemas';
import type { TFuncKey } from 'i18next';
import type { ReactNode } from 'react';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';

import DynamicT from '@/shared/components/DynamicT';
import FirstScreenLayout from '../FirstScreenLayout';
import styles from './index.module.scss';

type ThirdPartyBranding = ConsentInfoResponse['application']['branding'];

type Props = {
  readonly children: ReactNode;
  readonly title: TFuncKey;
  readonly titleInterpolation?: Record<string, unknown>;
  readonly thirdPartyBranding?: ThirdPartyBranding;
};

const LandingPageLayout = ({ children, title, titleInterpolation}: Props) => {
  const { experienceSettings, theme } = useContext(PageContext);

  if (!experienceSettings) {
    return null;
  }

  return (
    <FirstScreenLayout pageMeta={{ titleKey: title, titleKeyInterpolation: titleInterpolation }}>
      {title && (
        <div className={styles.title}>
          <DynamicT forKey={title} interpolation={titleInterpolation} />
        </div>
      )}

      {children}
    </FirstScreenLayout>
  );
};

export default LandingPageLayout;
